"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/components/Configure.js
// module id = 1027
// module chunks = 142807904292071